import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.25rem'
  },
  container: {
    width: '51%',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  textBlockWSide: {
    flexWrap: 'nowrap',
    marginBottom: '2.3rem'
  },
  textBlock: {
    width: '58%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  card: {
    background: 'linear-gradient(#FECCF4, #FBC143)',
    width: '41%',
    padding: '1.5rem',
    marginLeft: '2.4rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '2.3rem',
      marginLeft: 0
    }
  },
  listItem: {
    ...theme.typography.body2
  },

  //   ------------------------------------------
  boldFont: {
    fontFamily: 'proximaNovaB'
  }
}));

const celtra = `<div class="celtra-ad-v3">
<img src="data:image/png,celtra" style="display: none" onerror="
    (function(img) {
        var params = {'clickUrl':'','expandDirection':'undefined','preferredClickThroughWindow':'new','clickEvent':'advertiser','externalAdServer':'Custom','tagVersion':'html-standard-7'};
        var req = document.createElement('script');
        req.id = params.scriptId = 'celtra-script-' + (window.celtraScriptIndex = (window.celtraScriptIndex||0)+1);
        params.clientTimestamp = new Date/1000;
        params.clientTimeZoneOffsetInMinutes = new Date().getTimezoneOffset();
        params.hostPageLoadId=window.celtraHostPageLoadId=window.celtraHostPageLoadId||(Math.random()+'').slice(2);
        var qs = '';
        for (var k in params) {
            qs += '&amp;' + encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        }
        var src = 'https://ads.celtra.com/30173db9/web.js?' + qs;
        req.src = src;
        img.parentNode.insertBefore(req, img.nextSibling);
    })(this);
"/>
</div>`;

const HowHologic = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      id="howHologicCont"
      container
      direction="column"
      alignItems="center"
      className={classes.wrapper}
    >
      <Grid container className={classes.container}>
        <Typography variant="h2">How Hologic is Helping</Typography>
        <Typography variant="body1" style={{ margin: '2.3rem 0' }}>
          Hologic’s Project Health Equality is an innovative, holistic approach to solving the
          systemic and cultural issues in America’s medical system. With the following pillars,
          Hologic is setting forth a radical new model that can serve as a north star for the rest
          of the healthcare industry:
        </Typography>
        <Typography variant="body1" style={{ marginBottom: '2.3rem' }}>
          <span className={classes.boldFont}>Research</span>
          <br />
          Hologic and its partners are conducting research that digs deep into disparities to make
          certain that Black and Hispanic women can access and receive a high standard of care. This
          work will also inform the company’s next steps on the path to scalable solutions.
        </Typography>
        <Grid
          container
          alignItems="flex-start"
          direction={matchesSM ? 'column' : 'row'}
          className={classes.textBlockWSide}
        >
          <Grid container className={classes.textBlock}>
            <Typography variant="body1">
              <span className={classes.boldFont}>Awareness & Education </span>
              <br />
              Hologic has partnered with the Black Women’s Health Imperative and the National
              Alliance for Hispanic Health to develop and disseminate communications that will
              assist health care professionals, providers, community health workers, and
              policymakers in carrying out solutions to address the obstacles that impact Black and
              Hispanic women’s healthcare
            </Typography>
          </Grid>
          <Grid container item className={classes.card}>
            <Typography variant="body2" className={classes.boldFont}>
              Tips for Self-Advocacy:
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>Ask your provider lots of questions</li>
              <li className={classes.listItem}>Research symptoms and monitor them closely</li>
              <li className={classes.listItem}>Talk to other women</li>
              <li className={classes.listItem}>Understand your genetic risks</li>
              <li className={classes.listItem}>Don’t let insurance companies prohibit your care</li>
            </ul>
          </Grid>
        </Grid>
        <Grid container className={classes.textBlock2}>
          <Typography variant="body1">
            <span className={classes.boldFont}>Access to Care</span>
            <br /> In collaboration with RAD-AID, Hologic is widening the delivery of high-quality
            care—from screenings to treatment—for thousands of underserved Black and Hispanic women.
            Both companies are coming together to partner with Federally Qualified Health Care
            Centers, local community health clinics, and tertiary care institutions across the
            United States to provide greater access to better health care.
          </Typography>
        </Grid>
        <Grid id="celtraCont" container style={{ marginTop: '6.25rem' }}>
          <a
            href="https://cts.businesswire.com/ct/CT?id=smartlink&url=http%3A%2F%2Fwww.hologic.com%2Fprojecthealthequality&esheet=52426870&newsitemid=20210511005313&lan=en-US&anchor=www.hologic.com%2Fprojecthealthequality&index=1&md5=8c6a3877dbe4300e4a7e26ce797be2d6"
            style={{ width: '100%' }}
          >
            {' '}
            <div dangerouslySetInnerHTML={{ __html: celtra }} />
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HowHologic;
